import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-modal";
import { format, addDays } from "date-fns";
import { fetchPTTrainerPerformanceData } from "../../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  currentMonthNumber,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PtDetails from "../trainer-details/common/PtDetails";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import { months } from "../../common-data/DropdowData";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const PTTrainerPerformance = ({ userInfoData, prevSelGym, prevSelDate }) => {
  const dispatch = useDispatch();
  const { ptTrainerPerformanceLoading, ptTrainerPerformance } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : prevSelGym
        ? prevSelGym
        : "",
    selectedTrainer: "",
    selectedMonth:
      months.find((month) => month.value === currentMonthNumber.toString()) ||
      "",
    selectedStartDate: prevSelDate?.startDate ? prevSelDate.startDate : "",
    selectedEndDate: prevSelDate?.endDate ? prevSelDate.endDate : "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    month: allFilters.selectedMonth?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniPTDatas = {
    pagination: [],
    allTrainers: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniClickVals = {
    isModOpen: false,
    cardName: "",

    rowData: "",
    trainerId: "",
    gymId: "",
    viewImage: "",
    userName: "",
    userNo: "",
  };
  const [clickValues, setClickValues] = useState(iniClickVals);
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  function getPTTrainerPerformance(filters) {
    dispatch(
      fetchPTTrainerPerformanceData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    setClickValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardName: name,

      trainerId: row?.trainer_id || "",
      gymId: row?.gym_id || "",
    }));
  };

  function onCloseModal() {
    setClickValues(iniClickVals);
  }

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilter);
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && !isManagerRole
          ? {
              label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : prevSelGym
          ? prevSelGym
          : "",
    }));
  }, [prevSelGym, userInfoData?.gym_id]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedMonth:
        months.find((month) => month.value === currentMonthNumber.toString()) ||
        "",
    }));
  }, [prevSelGym]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      month: allFilters.selectedMonth?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selectedMonth,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
  ]);

  useEffect(() => {
    getPTTrainerPerformance(filters);
  }, [filters]);

  useEffect(() => {
    if (
      ptTrainerPerformance?.status &&
      ptTrainerPerformance?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allTrainers: ptTrainerPerformance.data,
        pagination:
          ptTrainerPerformance?.pagination?.length > 0
            ? ptTrainerPerformance.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [ptTrainerPerformance]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            <small>{row?.gym_name || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "Trainer Info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.trainer_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Shift Time",
      formatter: (cell, row) => {
        const formatTime = (time) => {
          if (!time) return "";

          const [hours, minutes] = time?.split(":");
          const hour = parseInt(hours, 10);
          const period = hour < 12 ? "AM" : "PM";
          const formattedHour = hour % 12 || 12;
          return `${formattedHour} ${period}`;
        };

        const formattedShifts =
          row?.shift_timing?.length > 0
            ? row?.shift_timing
                .map((shift) => {
                  return `${formatTime(shift?.start_time)} - ${formatTime(
                    shift?.end_time
                  )}`;
                })
                .join("<br>")
            : "-";

        return (
          <span
            className="tb-data minWidth150"
            dangerouslySetInnerHTML={{
              __html: formattedShifts || "NA",
            }}
          ></span>
        );
      },
    },
    {
      dataField: "salary",
      text: "salary",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "pt_sold_this_month_amount",
      text: "PT Sold This Month",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 minWidth150 link"
            onClick={(e) => onClickValues(e, row, "pt-this-month")}
          >
            ₹{convertThenFormat(row?.pt_sold_this_month_amount || 0)} (
            {row?.pt_sold_this_month || 0})
          </span>
        );
      },
    },
    {
      dataField: "total_active_client",
      text: "Active clients",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 link"
            onClick={(e) => onClickValues(e, row, "active")}
          >
            {row?.total_active_client || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expired_client",
      text: "Expired clients",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 link"
            onClick={(e) => onClickValues(e, row, "expired")}
          >
            {row?.total_expired_client || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expiring_this_month",
      text: "PT Members Expiring This Month",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 link"
            onClick={(e) => onClickValues(e, row, "expiring")}
          >
            {row?.total_expiring_this_month || 0}
          </span>
        );
      },
    },
    {
      dataField: "pt_lifetime_business_amount",
      text: "Lifetime PT Business Done",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 link"
            onClick={(e) => onClickValues(e, row, "all")}
          >
            ₹{convertThenFormat(row?.pt_lifetime_business_amount || 0)}
          </span>
        );
      },
    },
    {
      dataField: "pt_total_lifetime_lost",
      text: "Lifetime PT Business Lost",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 bold link"
            onClick={(e) => onClickValues(e, row, "pt_business_lost")}
          >
            ₹{convertThenFormat(row?.pt_total_lifetime_lost || 0)}
          </span>
        );
      },
    },
    {
      dataField: "overall_rankoverall_rank",
      text: "overall rank",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth90  withPadding borderRdius8"
            style={{
              background: "#157EF9",
              color: "#FFF",
            }}
          >
            {row?.overall_rank || 0}
          </span>
        );
      },
    },
    {
      dataField: "gym_rank",
      text: "gym rank",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth90  withPadding borderRdius8"
            style={{
              background: "#157EF9",
              color: "#FFF",
            }}
          >
            {row?.gym_rank || 0}
          </span>
        );
      },
    },
    {
      dataField: "joining_date",
      text: "joining date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.joining_date ? convertStraight(row.joining_date) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="PT Trainer Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/-/g, " ")}`}
            onClose={onCloseModal}
          />

          <PtDetails
            allInfo={clickValues}
            filters={filters}
            performanceEvaluation={true}
          />
        </div>
      </Modal>

      <div className="pt-track-stats-data personal-training mb30">
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>All PT Trainer Performance</Accordion.Header>

            <Accordion.Body>
              <CommonFilterStructure
                from={"pt-trainer-performance"}
                decryptedText={userInfoData}
                setFilters={setAllFilters}
                filters={allFilters}
                openDateRanger={openDateRanger}
                onClickReset={onClickReset}
                handleDateRangeChange={handleDateRangeChange}
                setOpenDateRanger={setOpenDateRanger}
                rangeState={rangeState}
                clearDateRanger={clearDateRanger}
              />

              <div className="fullWidthFlexCenter overflowAuto separatedTable">
                {ptTrainerPerformanceLoading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={
                      Array.isArray(allDatas.allTrainers) &&
                      allDatas.allTrainers.length > 0
                        ? allDatas.allTrainers
                        : []
                    }
                    tableColumns={tbColumns}
                    tablePagination={
                      Array.isArray(allDatas.pagination) &&
                      allDatas.pagination.length > 0
                        ? allDatas.pagination
                        : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                )}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};

export default PTTrainerPerformance;
